import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { filterBy, orderBy, process, State } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { EmployeeMultiselectDialog } from '../employee-popup/employee-popup.component';
import { CRMService } from '../../services/crm.service';
import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    CheckCall,
    Employee,
    SearchCheckCall,
    SearchCustomer
    //SearchOrderEventType
} from '../../models/models';

@Component({
    selector: 'check-call-grid',
    templateUrl: './check-call-grid.component.html',
    standalone: false
})
export class CheckCallGrid implements OnChanges, OnInit {
    @Input() quoteOrderID: number = 0;
    @Input() orderNumber: string = "";
    @Input() quoteOrderLineID: number = 0;
    @Input() isDisplayLocationOnly: boolean = false;
    @Input() isDisplayEventDescription: boolean = false;
    @Input() isCustomer: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Input() viewType: string = "quoteorder";
    @Input() readonly: boolean = false;

    @ViewChild(GridComponent, { static: false }) public checkCallGrid!: GridComponent;

    public checkCallID: number = 0;
    public isAddNew: boolean = false;
    public isEdit: boolean = false;
    public isCheckCallData: boolean = false;
    public checkCallListOrig: SearchCheckCall[] = [];
    public checkCallList: SearchCheckCall[] = [];
    public checkCallData: any[] = [];
    private allEmployees: Employee[] = [];
    public searchCustomer: SearchCustomer = {} as SearchCustomer;
    //public searchOrderEventTypes: SearchOrderEventType[] = [];
    //public checkCallEventTypes: SearchOrderEventType[] = []; //['CHK', 'FUT', 'TRP'];
    public isExcludeMP: boolean = true;
    public isExcludeRESET: boolean = true;

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 20, sort: [{ dir: 'desc', field: 'dateOfCall' }] };

    constructor(private dataService: DataService, private crmService: CRMService,
        private employeeService: EmployeeService, private orderService: OrderService,
        private utilService: UtilService,
        public dialog: MatDialog, private ngZone: NgZone) {
        //this.employeeService.getAllEmployees().subscribe(result => {
        //    this.allEmployees = result;
        //});
    }

    ngOnInit() {
        if (this.viewType == "order-tracking" || this.viewType == "tracking") {
            this.isExcludeMP = false;
        }
        //console.log("check-call-grid:ngOnInit", this.quoteOrderID, this.quoteOrderLineID, this.viewType, this.isExcludeMP);
    }

    ngOnChanges() {
        this.getCheckCalls();
        //if (this.isDisplayEventDescription == true) {
        //    this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
        //        this.searchOrderEventTypes = result;
        //        this.getCheckCalls();
        //    });
        //}
        //else {
        //    this.getCheckCalls();
        //}
        //console.log("check-call-grid:ngOnChanges", this.quoteOrderID, this.quoteOrderLineID);
    }

    public getEventName(code: string) {
        var name = code;
        //if (this.isDisplayEventDescription == true) {
        //    var eventType = this.searchOrderEventTypes.filter(t => t.code == code);
        //    if (eventType.length > 0) {
        //        name = eventType[0].reportDescription;
        //    }
        //}
        return name;
    }

    private getCheckCalls() {
        this.checkCallID = 0;
        this.isAddNew = false;
        this.isEdit = false;
        this.isCheckCallData = false;
        var eventTypeName = "";

        this.utilService.isLoading = true;
        if (this.viewType == "customs-exceptions") {
            eventTypeName = "Customs & Exceptions";
        }
        if (this.quoteOrderID > 0) {
            this.orderService.getSearchCheckCallByQuoteOrderID(this.quoteOrderID, eventTypeName).subscribe(result => {
                this.utilService.isLoading = false;
                this.checkCallListOrig = result.resultCollection;
                this.filterCheckCalls();
                this.setGrid();
            });
        }
        else if (this.quoteOrderLineID > 0) {
            this.orderService.getSearchCheckCallByQuoteOrderLineID(this.quoteOrderLineID, eventTypeName).subscribe(result => {
                this.utilService.isLoading = false;
                this.checkCallListOrig = result.resultCollection;
                this.filterCheckCalls();
                this.setGrid();
            });
        }
        else {
            this.utilService.isLoading = false;
        }
    }

    public viewCheckCallData(checkCall: SearchCheckCall) {
        this.isCheckCallData = true;
        var data = JSON.parse(checkCall.checkCallData);
        if (data != undefined && data != "") {
            var firstKey = Object.keys(data)[0];
            var firstObj = data[firstKey];
            this.checkCallData = firstObj;
            console.log("viewCheckCallData", firstKey, firstObj, data, this.checkCallData);
        }
    }

    public closeCheckCallData() {
        this.isCheckCallData = false;
    }

    private setGrid() {
        var data = this.checkCallList.slice();

        if (this.gridState.filter) data = filterBy(data, this.gridState.filter);
        if (this.gridState.sort) data = orderBy(data, this.gridState.sort);

        this.gridData = process(data, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.checkCallGrid == null) return;
            this.checkCallGrid.autoFitColumns();
        });
    }

    private filterCheckCalls() {
        this.checkCallList = Object.assign([], this.checkCallListOrig);
        if (this.isDisplayLocationOnly) {
            this.checkCallList = this.checkCallList.filter(t => t.latitude != 0 && t.longitude != 0);
        }
        if (this.isCustomer) {
            this.checkCallList = this.checkCallList.filter(t => t.isCustomerVisible == true && t.checkCallAction == "Completed");
        }
        if (this.isExcludeMP) {
            this.checkCallList = this.checkCallList.filter(t => t.eventCode != "MPCKC");
        }
        if (this.isExcludeRESET) {
            this.checkCallList = this.checkCallList.filter(t => t.orderEventTypeCode != "Reset");
        }
    }

    public toggleIsExcludeMP() {
        this.isExcludeMP = !this.isExcludeMP;
        this.filterCheckCalls();
        this.setGrid();
    }

    public toggleIsExcludeRESET() {
        this.isExcludeRESET = !this.isExcludeRESET;
        this.filterCheckCalls();
        this.setGrid();
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setGrid();
    }

    public edit(checkCall: CheckCall) {
        this.checkCallID = checkCall.checkCallId;
        this.quoteOrderLineID = checkCall.quoteOrderLineId;
        this.isAddNew = false;
        this.isEdit = true;
        this.isCheckCallData = false;
    }

    public addNew() {
        this.checkCallID = 0;
        this.isAddNew = true;
        this.isEdit = false;
        this.isCheckCallData = false;
    }

    public delete(checkCall: SearchCheckCall) {
        var checkCallIndex = this.checkCallList.findIndex(c => c.checkCallID == checkCall.checkCallID);

        if (checkCallIndex == null || checkCallIndex < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to delete this check call?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.orderService.deleteCheckCallById(checkCall.checkCallID).subscribe(result => {
                this.getCheckCalls();
                if (result && result == true) {
                    //this.checkCallList.splice(checkCallIndex, 1);
                }

                //this.setGrid();
            });
        });
    }

    public getCustomerAndSendEmail(dataItem: SearchCheckCall) {
        this.utilService.isLoading = true;
        this.crmService.getSearchCustomerByID(dataItem.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCustomer = result.resultCollection[0];
            //this.getCustomerTeamInfo(dataItem);
            this.sendCheckCallEmail(dataItem);
        });
    }

    private checkAndAddEmployee(employeeID: number, employees: Employee[]) {
        if (employeeID > 0) {
            var emp = this.allEmployees.find(t => t.employeeId == employeeID);
            if (emp != null) {
                var idx = employees.findIndex(e => e.employeeId == employeeID && e.email != "");
                if (idx == null || idx < 0) employees.push(emp);
            }
        }
        return employees;
    }

    private sendCheckCallEmail(checkCall: SearchCheckCall) {
        if (this.allEmployees.length > 0) {
            this.sendCheckCallEmailContinue(checkCall);
        }
        else {
            this.employeeService.getActiveEmployees().subscribe(result => {
                this.allEmployees = result;
                this.sendCheckCallEmailContinue(checkCall);
            });
        }
    }

    private sendCheckCallEmailContinue(checkCall: SearchCheckCall) {
        var employees: Employee[] = [];
        var extraEmails: string = "";

        if (this.searchCustomer.internalTrackingEmail != "") {
            extraEmails = this.searchCustomer.internalTrackingEmail;
        }
        else {
            employees = this.checkAndAddEmployee(this.searchCustomer.opsRepID, employees);
            employees = this.checkAndAddEmployee(this.searchCustomer.accountRepID, employees);
            employees = this.checkAndAddEmployee(checkCall.loadCreatedByEmployeeID, employees);
        }
        employees = this.checkAndAddEmployee(checkCall.csrEmployeeID, employees);

        const dialogRef = this.dialog.open(EmployeeMultiselectDialog, {
            data: {
                showNotes: false,
                showCheckCallNotes: true,
                showSystemNotes: true,
                employees: employees,
                extraEmails: extraEmails
            }
        });

        dialogRef.componentInstance.checkCallNotes = checkCall.checkCallNote;
        dialogRef.componentInstance.systemNotes = checkCall.comment;

        dialogRef.afterClosed().subscribe(result => {
            if (result == null ||
                ((result.selectedEmployees == null || result.selectedEmployees.length < 1) &&
                (result.selectedGroupId == null || result.selectedGroupId < 1) &&
                (result.selectedEmails == null || result.selectedEmails.length < 1))) return;

            var emails = '';
            //var trackingEmail = this.orderPageAppControls.find(a => a.appControl == 'Tracking Alert Email');
            //if (trackingEmail) {
            //    emails += trackingEmail.appSettingValue + '|';
            //}
            result.selectedEmployees.forEach(e => {
                emails += e.email + '|';
            });

            if (result.selectedEmails != null) {
                emails += result.selectedEmails + '|';
            }

            //console.log("sendQuoteOrderEmail", checkCall.quoteOrderID, "", emails, result.selectedGroupId, "", result.notes, true, false, checkCall.eventCode, false);

            this.orderService.sendQuoteOrderEmail(checkCall.quoteOrderID, "", emails, result.selectedGroupId, "", result.checkCallNotes, checkCall.checkCallID, result.checkCallNotes, true, false, checkCall.eventCode, false).subscribe(emailResult => {
                var ok = emailResult;
                this.getCheckCalls();
            });

            //this.orderService.sendOrderInfoEmail(dataItem.quoteOrderID, dataItem.quoteOrderLineID, dataItem.orderNumber, emails, result.selectedGroupId, "", result.notes, true, false, dataItem.eventCode, false).subscribe(emailResult => {
            //    var ok = emailResult;
            //});
        });
    }
}
